import type { MessageItem } from 'tripPlanner/components/Chat/MessagesList'

/**
 * Combines server messages with streaming overlay messages.
 * Uses ID-based deduplication - overlay messages take precedence over server messages
 * with the same ID (streaming updates, not yet persisted).
 */
export function combineMessages(
  serverMessages: Array<MessageItem>,
  pendingUserMessage: MessageItem | null,
  streamingMessage: MessageItem | null,
): Array<MessageItem> {
  const overlayIds = new Set<string>()
  if (pendingUserMessage) overlayIds.add(pendingUserMessage.id)
  if (streamingMessage) overlayIds.add(streamingMessage.id)

  const filteredServerMessages = serverMessages.filter(m => !overlayIds.has(m.id))

  const combined = [...filteredServerMessages]
  if (pendingUserMessage) combined.push(pendingUserMessage)
  if (streamingMessage) combined.push(streamingMessage)

  return combined
}
